<template>
    <div class="">
        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left">
                    <div class="header-item" @click="dashboard">
                        <img src="../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Detail Notifikasi</div>
                <div class="header-top--right">
                    <div class="header-item"></div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page">

            <div class="w-limit">
                <div class="main-pnotif  p-t-16 p-d-20 p-x-20">
                    <div class="category-pnotif">
                        Pemberitahuan
                    </div>
                    <div class="title-pnotif">
                        {{detail.nama}}
                    </div>
                    <div class="subtitle-pnotif">
                        {{detail.waktu}}

                    </div>

                    <div class="desc-pnotif" v-html="detail.deskripsi">

                    </div>


                </div>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        name: "Broadcast",
        data() {
            return {
                id: this.$route.query.id,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
                detail:{

                },
                data: {
                    1: {
                        id:"1",
                        waktu:"8 Jan 2021 / 20:19",
                        nama:"Update Intergasi Selesai Dilakukan",
                        deskripsi:" <p>\n" +
                            "                            Update integrasi data telah selesai, hal ini mungkin mempengaruhi data paket deposit &\n" +
                            "                            transaksi menggunakan deposit.\n" +
                            "\n" +
                            "                        </p>\n" +
                            "\n" +
                            "                        <p>\n" +
                            "                            1. Jika terdapat ketidaksesuaian data paket deposit, Anda dapat melakukan input ulang*\n" +
                            "                            sesuai dengan file excel data paket deposit yang telah Anda simpan.\n" +
                            "\n" +
                            "                            <span style=\"color:#f00\">\n" +
                            "                        *Pastikan Anda menginputkan “Nama Paket Deposit” sama persis dengan nama yang ada di file excel untuk memastikan saldo deposit konsumen Anda tidak hilang.\n" +
                            "\n" +
                            "                        </span>\n" +
                            "\n" +
                            "                        </p>\n" +
                            "                        <p>\n" +
                            "                            2. Jika tidak dapat melakukan transaksi menggunakan deposit, pastikan Anda telah melakukan\n" +
                            "                            input ulang data paket deposit sesuai file exel pencadangan. Kemudian, Anda dapat\n" +
                            "                            mengirimkan file exel data saldo deposit konsumen (resume_deposit) yang telah Anda simpan\n" +
                            "                            melalui CS. Tim teknis Smartlink akan memproses pemulihan saldo deposit konsumen dengan\n" +
                            "                            waktu pemrosesan maksimal 1x24 jam.\n" +
                            "\n" +
                            "                        </p>"
                    },  2: {
                        id:"2",
                        waktu:"8 Jan 2021 / 20:19",
                        nama:"Update Fitur! Pengaturan Absen",
                        deskripsi:"<p> Halo, Smart Owner. Tingkat keamanan fitur absen kini sudah ditingkatkan dengan adanya pengaturan Lokasi Outlet. Dengan pengaturan lokasi outlet ini, Karyawan hanya dapat melakukan upload bukti kehadiran di titik lokasi outlet yang sudah diatur owner. </p>\n" +
                            "\n" +
                            "Atur lokasi outlet di aplikasi Smart Owner pada menu Outlet & Workshop -> pilih Outlet -> Pengaturan Absen Karyawan -> Atur Radius Outlet dengan klik \"Atur Lokasi Outlet\""
                    },
                }
            }
        },
        mounted() {
            this.detail=this.data[this.id]
        },
        watch: {
            '$route' (route, oldroute) {
                var urlBos = route.query.id
                var params = route.query.id
                if (route.query.id === undefined) {
                    const url = new URL(window.location.href);
                    url.searchParams.set('id', oldroute.query.id);
                    window.history.replaceState(null, null, url);

                }
            }
        },
        methods: {
            goRouteNotif: function (route) {
                this.$router.push({name: route})
            },


            dashboard() {
                this.$router.push({name: 'dashboard'})
            },
            toMenuEkspor() {
                $('html, body').animate({
                    scrollTop: $("#end-menu-ekspor").offset().top
                }, 1000);
            },
            scroll() {
                window.onscroll = () => {
                    let visible = this.checkVisible("#end-menu-ekspor")

                    if (visible) {
                        $(".btn-more").hide();
                    } else {
                        $(".btn-more").show();
                    }
                }
            },
            checkVisible(elm, evalType) {

                evalType = evalType || "visible";

                var vpH = $(window).height(), // Viewport Height
                    st = $(window).scrollTop(), // Scroll Top
                    y = $(elm).offset().top,
                    elementHeight = $(elm).height();

                if (evalType === "visible") return ((y < (vpH + st)) && (y > (st - elementHeight)));
                if (evalType === "above") return ((y < (vpH + st)));
            }

        }

    }

    // alert($(".nav-bottom--inner").outerHeight())

</script>


<!-- Style css -->
<style scoped>

    .overloading {
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: #686868ed;
        z-index: 9;
        text-align: center;
        color: #fff;
        padding-top: 20px;
        font-size: 18px;
    }

    .inner-panel-item {
        position: relative;
    }

    .wrapper-more {
        z-index: 9;
        position: fixed;
        bottom: 100px;
        left: 0px;
        right: 0px;
        width: 100%;
        text-align: center;
    }


    .category-pnotif {
        color: #4A85FF;
        font-size: 12px;
    }

    .title-pnotif {
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 4px;
    }

    .subtitle-pnotif {
        color: #6F7287;
        font-size: 12px;
        margin-bottom: 16px;
    }

    .desc-pnotif {
        margin: 0px 0px;
        padding: 20px 0px;
        font-size: 16px;
        color: #333333;
        border-top: dashed 1px #cacaca;
        line-height: 155%;
        /* or 25px */
        letter-spacing: -0.02em;
    }

    .circular--portrait img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }


    .paylink-panel .paylink-top-panel {
        background: linear-gradient(270deg, #4CA1AF 0%, #1C54C4 100%);
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 41px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .paylink-panel .paylink-balance {
        color: white;
        font-weight: 600;
    }

    .paylink-panel .paylink-bottom-panel {
        display: flex;
        justify-content: space-around;
        padding: 8px 0px;
    }

    .paylink-panel .paylink-bottom-panel .icon-panel {
        width: 28px;
        height: 28px;
        margin: auto;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }


    .inner-panel {
        border: 1px solid #EDEDED;
        border-radius: 3px;
    }

    .inner-panel .inner-panel-item {
        padding: 12px 48px 12px 16px;
        position: relative;
    }

    .inner-panel .inner-panel-item:not(:first-child),
    .inner-panel .inner-panel-12:not(:first-child) {
        border-top: 1px solid #EDEDED;
    }

    .splide-wrapper .splide__slide img {
        vertical-align: middle;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }


    .splide-wrapper.splide-info .splide__slide img {
        height: 120px;
        border-bottom: 1px solid #C8D0DD;
    }
</style>